import trackAppleWatchGallerySlideView from '../track-event/apple-watch-gallery-slide-view';
import trackAppleWatchGallerySlideOpen from '../track-event/apple-watch-gallery-slide-open';
import trackAppleWatchGallerySlideClose from '../track-event/apple-watch-gallery-slide-close';
import trackAppleWatchGallerySlideInaction, { EVENT_NAME as SCREENSHOT_INACTION_EVENT_NAME } from '../track-event/apple-watch-gallery-slide-inaction';
import galleryTracker from './_gallery';



export default galleryTracker({
  SCREENSHOT_INACTION_EVENT_NAME,
  trackSlideView: trackAppleWatchGallerySlideView,
  trackSlideOpen: trackAppleWatchGallerySlideOpen,
  trackSlideClose: trackAppleWatchGallerySlideClose,
  trackSlideInaction: trackAppleWatchGallerySlideInaction
});



// WEBPACK FOOTER //
// ./src/lib/bind-event-tracking/apple-watch-gallery.js